module.exports = __webpack_public_path__ + "img/07.a80da255.gif";